import moment from "moment";
import { Day } from "../interface/form";

export function convertDateStringToLocaleString(dateString: string) {
    const formattedDate = moment.utc(dateString).toDate();
    return formattedDate;
}

export function getAllDatesInYear(year: number) {
    // get past 6 month date and next 2month date
    const previousDates: Date[] = [];
    const futureDates: Date[] = [];
    const today = new Date();

    const dateStart = new Date(Date.UTC(2023, 8, 1));

    const twoMonthsAhead = new Date();
    twoMonthsAhead.setMonth(twoMonthsAhead.getMonth() + 2);

    const currentDate = new Date(dateStart.getTime() - 8 * 60 * 60 * 1000);

    while (currentDate <= twoMonthsAhead) {
        if (currentDate <= today) {
            previousDates.push(new Date(currentDate)); // Add to previous dates array
        } else {
            futureDates.push(new Date(currentDate)); // Add to future dates array
        }
        currentDate.setDate(currentDate.getDate() + 1); // Increment the date by 1
    }

    const allDates = previousDates.reverse().concat(futureDates); // Concatenate the arrays

    return allDates;
}

export function ConvertWeekDayToNumber(weekday: Day) {
    switch (weekday) {
        case "Monday":
            return "1";
        case "Tuesday":
            return "2";
        case "Wednesday":
            return "3";
        case "Thursday":
            return "4";
        case "Friday":
            return "5";
        case "Saturday":
            return "6";
        case "Sunday":
            return "7";
    }
}

export function getCurrentDate() {
    let currentDate = new Date();
    let year = currentDate.getFullYear();
    let month = String(currentDate.getMonth() + 1).padStart(2, "0");
    let day = String(currentDate.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}
